import {
  PromptGroup,
  PromptGroupKind,
  PromptItem,
} from '../../../../types/candidateStories';

export const getPromptGroupByKind = (
  promptGroups: PromptGroup[] | null,
  kind: PromptGroupKind,
): PromptGroup | null => {
  if (!promptGroups) return null;

  return (
    promptGroups.find(group => group.enabled && group.kind === kind) || null
  );
};

export const getGeneralPromptGroup = (
  promptGroups: PromptGroup[] | null,
): PromptGroup | null => {
  return getPromptGroupByKind(promptGroups, PromptGroupKind.GENERAL);
};

export const getCriminalPromptGroup = (
  promptGroups: PromptGroup[] | null,
): PromptGroup | null => {
  return getPromptGroupByKind(promptGroups, PromptGroupKind.CRIMINAL);
};

export const findItemTranslation = (
  promptItem: PromptItem | null,
  lang: string,
) => {
  if (!promptItem) {
    return null;
  }

  return (
    promptItem.translations.find(t => t.language === lang) ||
    promptItem.translations.find(t => lang.startsWith(t.language)) ||
    promptItem.translations.find(t => t.language === 'en')
  );
};
